module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Twirl")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "serfx"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "more",
      "id": "p0013-d6e12",
      "src": "images/97808499229_0013_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#cnt_1",
      "id": "ctn_1"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#cnt_1"
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0013-03-1"
    }
  }, [_c('span', [_c('i', [_vm._v("If the doors of perception were cleansed, everything would appear to man as it is—infinite.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "p0013-03-2"
    }
  }, [_c('span', [_vm._v("—W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("Did you know you are more than you realize? Inside of")]), _vm._v(" you are untapped veins of surprising potential.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-5"
    }
  }, [_vm._v("It’s true.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-05-6"
    }
  }, [_vm._v("Not only that, but your friends, husband, boss, children—they are more as well. They have unexplored talent, hidden even from themselves. It’s not the fact they have potential that surprises us, but it’s the unexpected ways it comes out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("And then there’s God’s limitlessness. Talk about “more.” We think at times we have the Lord figured out so we can fully explain him to others, when—"), _c('i', [_vm._v("kaboom!")]), _vm._v("—he explodes our theories. God is not bound by time or even our theology. He can’t be conveniently contained or tidied up to fit our beliefs. He is so much more.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-1"
    }
  }, [_vm._v("This is great news.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-2"
    }
  }, [_vm._v("For one thing, when we understand our potential to be more than we know, it allows us to break free from other people’s opinions. In fact, when my sister-in-law Candy was a child, she would cry if you said the word "), _c('i', [_vm._v("opinion")]), _vm._v(". We think it was the word "), _c('i', [_vm._v("pin")]), _vm._v(" that made it sound threatening to her. And actually it can be painful to have people’s narrow judgments pin us down. Especially if we buy into their assessment and allow it to restrict our development.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-3"
    }
  }, [_vm._v("I watched a child who was continually told she was clumsy grow up, and it became a self-fulfilling prophecy. To this day she trips over gnats and is bound by the duct tape of people’s criticism. But in the same way I’ve also seen youngsters grow into more than I thought possible because they had people around them with openhanded grace. Somehow grace adds space for people’s uncharted hearts to be safely explored.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("I have to remind myself that people can restrict us only with our permission. As children we are vulnerable, but once we grow into our adult years we are instructed to “put away childish things” (1 Corinthians 13:11). It seems to me that one of those childish things is the judgment of others that comes from their brokenness and ignorance. Unfortunately I have been on both sides of that human ailment. I have been the one being critical and the one who had criticism heaped on her. Giving up my childish right to ")]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v(" hold a grudge toward the “heapers” in my life has accelerated my healing and deepened my realization and compassion for my own inconsistencies.")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-1"
    }
  }, [_vm._v("We are fragile people . . . yet full of surprises.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-2"
    }
  }, [_vm._v("About a dozen years ago we were visiting with friends when my husband, Les, was asked if he could go back in time what he would choose to do as an occupation. Well, we’d been married almost forty years at that time, so I knew with certainty what his answer would be. Actually, I knew a list of jobs he would have valiantly pursued. But when he said something that was not on the list, I was confused. I mean, it made perfect sense when I thought about it, but how in forty years had it never come up?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-3"
    }
  }, [_vm._v("I’m telling you, there’s more to folks than we realize. Just about the time we think there’s nothing they could do that would surprise us . . . they do. They are like piñatas, chock-full of unexpected goodies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-4"
    }
  }, [_vm._v("Years ago, when I slowly emerged from my agoraphobic restrictions, I began learning things about myself I didn’t know, nor did others. I remember a friend commenting after seeing my new spin on our living room arrangement that she didn’t know I could decorate. After she left I thought about her comment. I realized I’d never given her reason to know because I couldn’t handle people’s judgment if I didn’t do it “right.” So I didn’t risk it at all. When I began letting go of doing things perfectly, I gradually began to venture into untested territory. Guess what I found out? I love decorating . . . in my own bohemian way. It’s an artsy expression that pleases me because it helps tie me into the creative heart of God.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("Risk is risky. Yes, you may quote me. Risk means we don’t ")]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" know the outcome; it could go in our favor or work against us. The “against us” part was the threat that held me back. For years I didn’t have the internal flexibility to withstand rejection and what felt like condemnation, which I was already heaping on myself.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-1"
    }
  }, [_vm._v("I allowed a great deal of my worth to hang on other people’s opinions. And I often treated their opinions as my gospel, in that I allowed their assessments to govern my life. No wonder the scripture on renewing the mind became so important to my recovery. I needed a new understanding of the gospel, one that offered me liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0016-02-3"
    }
  }, [_c('span', [_vm._v("And do not be conformed to this world, but be transformed by the renewing of your mind, that you may prove what "), _c('i', [_vm._v("is")]), _vm._v(" that good and acceptable and perfect will of God. (Romans 12:2) ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-4"
    }
  }, [_vm._v("It wasn’t that I didn’t know the Liberator; it was I didn’t know how to exchange my shaky beliefs for the truth of who I was in Christ. That’s where I’d find my freedom, in his forgiveness and his promise of a future and a hope. I began studying Scripture, meditating, and praying . . . and ever so slowly, the seeded lies were dislodged from my beliefs. I joined a Bible study group in my community and developed friendships with women who were secure enough in their identities to affirm me, and ones who modeled social graces that I lacked. That was restorative. I became more aware of God’s daily kindnesses toward me.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("The Lord knows we are more because he designed us. Rest on that thought for a moment. God thought us up. Isn’t that amazing? ")]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" He created us for a purpose, and as long as there is breath in our bodies we can grow, change, and become more, much more than we expected.")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-1"
    }
  }, [_vm._v("My friend Karen joined our poetry class, not realizing how many beautiful words nested inside of her. I watched her take on the class challenges with a full heart of vulnerability, which caused her unspoken words to spill out into poetic word pictures. Every week Karen would shake her head in wonder and say, “I don’t know where this is coming from. I didn’t know it was in me.” It’s been lovely to watch the poet in her bloom and to witness her half-formed thoughts find shape and expression.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-2"
    }
  }, [_vm._v("We are more than we know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-3"
    }
  }, [_vm._v("Recently friends came for a visit. I had not seen my friend’s husband in close to forty years. He knew me when I was still working through the sticky wickets of agoraphobia leftovers. I wasn’t housebound by then, but I was living a restricted life based on my anxiety. At one point in our conversation he said, “Did you ever expect you’d be traveling, speaking, and writing?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-4"
    }
  }, [_vm._v("“No,” I confessed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-5"
    }
  }, [_vm._v("“Me either,” he admitted. “I told my friends who have heard you speak, that is not the Patsy I knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-6"
    }
  }, [_vm._v("“I’m as surprised as you are,” I said, wagging my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-7"
    }
  }, [_vm._v("I had no idea what God’s plan was for me. Had I known I’m sure I would have pulled a Jonah and hotfooted it down to Joppa. I would not have believed I could have traveled this cross-country, public path I’ve been on for the past thirty-eight years. Remember me, the agoraphobic? What was God thinking, saying, "), _c('i', [_vm._v("Lights, cameras, action?")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("We are more than we know.")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-1"
    }
  }, [_vm._v("Last year, like my friend Karen, I, too, joined my first poetry class. My bones were bruised from knocking because even though I had written an armload of books, I had not explored the inner landscape of poetry. I, too, was surprised by the words that poured out of me. First a trickle, then a stream, and at times a river. I think what surprised me most was how revealing my poems were about my heart. It became therapy. One of our assignments was about feet, and since I’ve traveled for so many years, this is what came out:")]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0018-02-3"
    }
  }, [_c('span', [_c('b', [_vm._v("Feet of a Million Miles ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0018-P-1"
    }
  }, [_c('span', [_c('i', [_vm._v("Traversing craggy hills of hardship, "), _c('br'), _vm._v("Stinging sands of unspoken sympathies, "), _c('br'), _vm._v("Valleys of deep regret . . ."), _c('br')])]), _c('span', [_c('i', [_vm._v("March on ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0018-P-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Just ahead: rivers, "), _c('br'), _vm._v("Rainbows, "), _c('br'), _vm._v("And silver-flecked sunsets, "), _c('br'), _vm._v("Amber with hope.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "p0018-P-3"
    }
  }, [_c('span', [_c('i', [_vm._v("Step lively your treck nears a turn, "), _c('br'), _vm._v("Where flowers weep tomorrow’s seeds, "), _c('br'), _vm._v("And sparrows rise to ride rain clouds."), _c('br')])]), _c('span', [_c('i', [_vm._v("You’ll rest soon.")])])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-04-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("I have had fun sharing my poetry with friends. Some like it; others not so much. It has been interesting to find that I’m not ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" swayed by either response, pro or con, because I finally, finally . . . recognize that I am a work in progress. Sometimes growth can only be measured by where we’ve been, not by what others are doing. (You might want to back up and read that sentence again.)")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-1"
    }
  }, [_vm._v("There’s more to me than I know. Golly, it’s taken me a whole lifetime to figure that out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-2"
    }
  }, [_vm._v("Don’t take that long. Start now. Believe for more. Believing helps bring into the light that which has been tucked inside you all along.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-3"
    }
  }, [_vm._v("Remember there’s a difference between an opinion of man and a principle of God. Our more-ness is a direct result of his muchness. It’s not about our ability, but his generosity. It’s about the Giver of light and every good gift.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-4"
    }
  }, [_vm._v("Embrace it . . . you are more than you know."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("1. This week, try a conversation with someone you know that offers them space to discover some of their more. Ask questions to help spur them to search inside, but be careful not to violate their privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("2. Name three things you’d like to do in your lifetime that you haven’t already done.")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("3. If you had a jet to fly anywhere in the world, where would you go? What five people would you take with you?")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("4. If you could play an instrument for your personal enjoyment, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "ol"
  }, [_vm._v("5. What color would you choose to represent your life?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0